import React, { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { api, formatApiError } from "../lib/api";
import { Envelope, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-[color:var(--cc-bg-2)]">
        <div className="max-w-md mx-auto px-4 py-12 sm:py-16">
          <div className="label-tag text-neutral-500">Forgot password</div>
          <h1 className="font-display font-black text-3xl mt-1">Reset your password</h1>

          {sent ? (
            <div className="mt-8 bg-[color:var(--cc-yellow)] border border-black p-6" data-testid="forgot-sent">
              <CheckCircle size={28} weight="fill" />
              <div className="font-display font-black text-xl mt-2">Check your email</div>
              <p className="mt-2 text-sm">If an account exists for <span className="font-mono-cc">{email}</span>, we've sent a reset link. It's valid for 60 minutes.</p>
              <Link to="/cardholder/login" className="mt-4 inline-block label-tag underline">Back to login</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4 bg-white border border-black p-6" data-testid="forgot-form">
              <div>
                <label className="label-tag flex items-center gap-2"><Envelope size={14} weight="bold" /> Email</label>
                <input type="email" className="mt-2 w-full px-4 py-3 border border-black outline-none" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
              </div>
              {error && <div className="label-tag text-red-600">{error}</div>}
              <button type="submit" disabled={submitting} className="w-full bg-black text-white label-tag px-4 py-4 brutal-btn disabled:opacity-60" data-testid="forgot-submit">
                {submitting ? "Sending…" : "Send reset link"}
              </button>
              <Link to="/cardholder/login" className="block text-center label-tag underline">Back to login</Link>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
